import { v4 as uuid } from 'uuid';
import { IGizmo, IGizmoData, IError } from '../../types';

interface IParams {
  config: IGizmo;
  data?: IGizmoData | IGizmoData[];
}

/**
 * Text field specific validations
 *
 * @param {IGizmo} config the text_field gizmo config
 * @param {IGizmoData | IGizmoData[]} data gizmo's data
 * @returns
 */
function textFieldValidations({ config, data }: IParams): IError[] {
  const errors: IError[] = [];

  if (
    config.ops?.textField &&
    data &&
    !Array.isArray(data) &&
    data['v'] &&
    typeof data['v'] === 'string'
  ) {
    const value = data['v'];
    const options = config.ops.textField;

    if (options.regex) {
      let message: string | undefined = options.regex.errorMessage;

      if (options.regex.type === 'email') {
        const regex = new RegExp(
          '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}\\s?$'
        );

        if (!regex.test(value)) {
          if (!message) {
            message = 'No es un correo válido';
          }

          errors.push({
            fid: uuid(),
            code: 'text_field.regex.email',
            message,
          });
        }
      } else if (options.regex.type === 'rfc') {
        const regex = new RegExp('^[A-ZÑ&]{3,4}\\d{6}[A-V1-9][A-Z1-9][0-9A]$');

        if (!regex.test(value)) {
          if (!message) {
            message = 'No es un RFC válido';
          }
          errors.push({
            fid: uuid(),
            code: 'text_field.regex.rfc',
            message,
          });
        }
      } else if (options.regex.type === 'curp') {
        const regex = new RegExp(
          '^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$'
        );

        if (!regex.test(value)) {
          if (!message) {
            message = 'No es un CURP válido';
          }
          errors.push({
            fid: uuid(),
            code: 'text_field.regex.curp',
            message,
          });
        }
      } else if (options.regex.type === 'custom' && options.regex.customRegex) {
        const regex = new RegExp(options.regex.customRegex);

        if (!regex.test(value)) {
          if (!message) {
            message = 'No se está cumpliendo la expresión regular configurada';
          }
          errors.push({
            fid: uuid(),
            code: 'text_field.regex',
            message,
          });
        }
      }
    }

    if (options.password?.isPassword) {
      if (value.length < 8) {
        errors.push({
          fid: uuid(),
          code: 'text_field.password',
          message: 'El password debe tener mas de 8 caracteres',
        });
      }
    }

    if (options.maxLength && value) {
      if (value.length > options.maxLength) {
        errors.push({
          fid: uuid(),
          code: 'text_field.max-length',
          message: `El valor debe de tener máximo ${options.maxLength} caracteres`,
        });
      }
    }

    if (options.minLength && value) {
      if (value.length < options.minLength) {
        errors.push({
          fid: uuid(),
          code: 'text_field.min-length',
          message: `El valor debe de tener mínimo ${options.minLength} caracteres`,
        });
      }
    }
  }

  return errors;
}

export default textFieldValidations;
